import React, { useCallback, useState } from "react";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import Swal from "sweetalert2";
import { AXIOS_UPLOAD_IMAGE } from "../../server/api/crud";

const ImageUpload = ({ formData, setFormData, fileInputRef, user }) => {
  const [image, setImage] = useState(formData?.avatar);
  const [loading, setLoading] = useState(false);
  const currentAvatar = formData?.avatar || image;

  const onValueChangeFile = useCallback(
    async (event) => {
      const item = event.target;
      const selectedFile = item.files?.[0];
      if (!selectedFile || !user?.id) return;
      
      setLoading(true);
      try {
        const response = await AXIOS_UPLOAD_IMAGE("users", user.id, selectedFile);
        const avatarURL = response?.data?.avatarURL;
        if (!response?.data?.success || !avatarURL) {
          throw new Error(response?.data?.message || "Upload failed");
        }

        setImage(avatarURL);
        setFormData((prev) => ({
          ...prev,
          avatar: avatarURL,
        }));
        Swal.fire(`Bestand ${selectedFile?.name} is opgeladen`, "", "success");
      } catch (error) {
        Swal.fire("Upload failed", "", "error");
      } finally {
        setLoading(false);
        item.value = "";
      }
    },
    [setFormData, user?.id]
  );

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="sm:col-span-3">
      <input
        type="file"
        id="avatar"
        name="avatar"
        accept="image/*"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={onValueChangeFile}
      />
      <label
        htmlFor="avatar"
        className="block text-[11px] font-semibold uppercase tracking-wide text-wa-muted"
      >
        Profielfoto
      </label>
      <div className="mt-2 flex items-center gap-x-4">
        {currentAvatar ? (
          <img
            className="h-24 w-24 flex-none cursor-pointer rounded-full bg-wa-panel2 object-cover ring-1 ring-wa-border"
            onClick={handleButtonClick}
            src={currentAvatar}
            alt="Profielfoto"
          />
        ) : (
          <UserCircleIcon
            className="h-24 w-24 cursor-pointer text-wa-muted"
            onClick={handleButtonClick}
            aria-hidden="true"
          />
        )}
        <button
          type="button"
          onClick={handleButtonClick}
          disabled={loading}
          className="rounded-xl border border-wa-border bg-wa-panel2/60 px-3 py-2 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover"
        >
          {loading ? "Uploaden..." : "Wijzig profielfoto"}
        </button>
      </div>
    </div>
  );
};

export default ImageUpload;
